var map = {
	"./cpm_client/404": 899,
	"./cpm_manager/404": 2215,
	"./opac/404": 2216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3204;


//////////////////
// WEBPACK FOOTER
// ./routes/404/components ^\.\/.*\/404$
// module id = 3204
// module chunks = 121